import { Button, TooltipDialog } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import InfoIcon from "@/icons/InfoIcon";
import {
  toolTipCss,
  toolTipIconCss,
  toolTipWrapperCss,
} from "./LevelToolTipDialog.style";

const TooltipDialogWithTrackEvent = withTrackEvent(TooltipDialog);

const propTypes = {
  assignmentId: PropTypes.string,
  currentContentLevelId: PropTypes.string,
};

const TOOLTIP_COPY =
  "To hide the Lexile level from students, first turn off “Students can change level”";

const LevelTooltipDialog = ({ assignmentId, currentContentLevelId }) => {
  return (
    <TooltipDialogWithTrackEvent
      __cssFor={toolTipCss}
      ariaProps={{ "aria-label": TOOLTIP_COPY }}
      body={<div css={toolTipWrapperCss}>{TOOLTIP_COPY}</div>}
      buttonContents={<InfoIcon css={toolTipIconCss} />}
      buttonProps={{ flavor: Button.flavors.incognito }}
      dataProps={{
        "data-qa-selector": "hide-lexile-level-from-students-tool-tip-dialog",
      }}
      dialogAriaProps={{
        "aria-label": "More information on hiding lexile level from students.",
      }}
      placement="top"
      // tracking props
      objectType={objectTypes.assignment}
      actionPrefix={actionPrefixes.initiate}
      actionName={actionNames.interact}
      streamProperties={{
        content_id: currentContentLevelId,
        content_type: "Article",
        description: "Open hide lexile level from students tooltip",
        objectId: assignmentId,
      }}
    />
  );
};

LevelTooltipDialog.propTypes = propTypes;

export default LevelTooltipDialog;
